<template>
    <div>
        <b-card no-body v-if="mostrarMenu">
            <b-card-body>
                <h4 class="heading-1 mb-4">
                    <span>CONTRATOS - Relatórios</span>
                </h4>
                <b-row class="mb-4">
                    <b-col lg="6" sm="12">
                        <b-list-group>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-01')"
                                :href="`#/contratos/relatorios/comprometimentossemregistropagamento`"
                                ><strong
                                    >Comprometimentos sem registro de
                                    pagamento</strong
                                >
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-02')"
                                :href="`#/contratos/relatorios/relacaonotasfiscais`"
                                ><strong>Relação de Notas Fiscais</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-03')"
                                :href="`#/contratos/relatorios/comprometimentosporcontrato`"
                                ><strong>Comprometimentos por Contrato</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-04')"
                                :href="`#/contratos/relatorios/contratosporgestor`"
                                ><strong>Contratos por Gestor</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-05')"
                                :href="`#/contratos/relatorios/valorespagosporcontratos`"
                                ><strong>Valores Pagos por Contratos</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-06')"
                                :href="`#/contratos/relatorios/contratosavisosaldo`"
                                ><strong>Contratos que já receberam aviso de saldo abaixo de 40%</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-07')"
                                :href="`#/contratos/relatorios/valortotalcontratos`"
                                ><strong>Valor Total dos Contratos</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-08')"
                                :href="`#/contratos/relatorios/consumoitenscontrato`"
                                ><strong>Consumo de quantidades de itens por requisição</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-04')"
                                :href="`#/contratos/relatorios/contratosvigentes`"
                                ><strong>Contratos Vigentes</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-04')"
                                :href="`#/contratos/relatorios/comprometimentosfaturamento`"
                                ><strong>Serviços Faturamentos</strong>
                            </b-list-group-item>
                            <b-list-group-item
                                v-if="$temAcessoView('CONT-REL-09')"
                                :href="`#/contratos/relatorios/contratosativosinativos`"
                                ><strong>Contratos Ativos/Inativos</strong>
                            </b-list-group-item>
                        </b-list-group>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
export default {
    computed: {
        mostrarMenu() {
            return this.$route.name == 'Contratos_Relatorios'
        }
    }
}
</script>

